<template>
  <div>
    <!-- Last flight session -->
    <div v-if="!isLogsMode" class="columns">
      <div class="column is-5">
        <input
          :id="idPrefix + 'sessionInput'"
          class="radio"
          type="radio"
          :name="idPrefix + 'retrieveTime'"
          value="sessionLast"
          v-model="option"
          @input="setByLastSessionRadio"
        />
        <label :for="idPrefix + 'sessionInput'" class="radio-label">{{ $t('sessionFilters.session_last') }}</label>
      </div>
    </div>

    <!-- Session number -->
    <div v-if="!isLogsMode && multi === false" class="columns">
      <div class="column is-5">
        <input
          class="radio"
          :id="idPrefix + 'sessionNumberInput'"
          type="radio"
          :name="idPrefix + 'retrieveTime'"
          value="sessionNumber"
          v-model="option"
          @input="setBySessionRadio"
        />
        <label :for="idPrefix + 'sessionNumberInput'" class="radio-label">{{ $t('sessionFilters.session_number') }}</label>
      </div>
      <div class="column">
        <div v-if="option === 'sessionNumber'" class="input-basic inline">
          <v-layout>
            <v-flex sm12>
              <v-text-field v-model="sessionNumber" :label="sessionLabel" @input="setBySession" />
            </v-flex>
          </v-layout>
        </div>
        <div v-else class="input-basic inline">
          <input type="text" disabled />
        </div>
      </div>
    </div>

    <!-- All sessions of day -->
    <div class="columns">
      <div class="column is-5">
        <input
          :id="idPrefix + 'allSessionsInput'"
          class="radio"
          type="radio"
          :name="idPrefix + 'retrieveTime'"
          value="sessionDate"
          v-model="option"
          @input="setSessionOfDayRadio"
        />
        <label :for="idPrefix + 'allSessionsInput'" class="radio-label">{{ $t('sessionFilters.session_day') }}</label>
      </div>
      <div class="column">
        <div v-if="option === 'sessionDate'" class="input-basic inline">
          <v-layout>
            <v-flex sm12>
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                :max-width="'290px'"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-bind="attrs"
                    v-on="on"
                    slot="activator"
                    :label="calendarLabel"
                    :value="formattedDate"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  no-title
                  scrollable
                  @input="setSessionOfDay"
                />
              </v-menu>
            </v-flex>
          </v-layout>
        </div>
        <div v-else class="input-basic inline">
          <input type="text" disabled />
        </div>
      </div>
    </div>

    <!-- All sessions between -->
    <div class="columns">
      <div class="column is-5">
        <input
          class="radio"
          type="radio"
          :id="idPrefix + 'sessionBetweenInput'"
          :name="idPrefix + 'retrieveTime'"
          value="sessionBetween"
          v-model="option"
          @input="setSessionBetweenRadio"
        />
        <label :for="idPrefix + 'sessionBetweenInput'" class="radio-label">{{ $t('sessionFilters.session_between') }}</label>
      </div>
      <div class="column">
        <div v-if="option === 'sessionBetween'" class="input-basic inline">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="30"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                v-on="on"
                slot="activator"
                :label="calendarRangeLabel"
                :value="formattedRange"
                readonly
              />
            </template>
            <v-date-picker
              v-model="dateRange"
              range
              scrollable
              no-title
              @input="setSessionBetween"
            >
              <v-spacer></v-spacer>
              <v-btn @click="closeDatePicker" color="primary" text>OK</v-btn>
            </v-date-picker>
          </v-menu>
        </div>
        <div v-else class="input-basic inline">
          <input type="text" disabled />
        </div>
      </div>
    </div>

    <!-- Select your sessions -->
    <div v-if="multi === false && !isLogsMode" class="columns">
      <div class="column is-5">
        <input
          :id="idPrefix + 'yourSessionInput'"
          class="radio"
          type="radio"
          :name="idPrefix + 'retrieveTime'"
          value="yourSession"
          v-model="option"
          @input="getSessionsRadio"
        />
        <label :for="idPrefix + 'yourSessionInput'" class="radio-label">{{ $t('sessionFilters.session_selected') }}</label>
      </div>
      <div class="column">
        <div v-if="option === 'yourSession'" class="input-basic inline">
          <v-layout>
            <v-flex sm12>
              <v-select
                v-model="selectedSessions"
                @input="setByYourSession"
                :items="yourSessionItems"
                :label="yourSessionLabel"
                multiple
                required
              ></v-select>
            </v-flex>
          </v-layout>
        </div>
        <div v-else class="input-basic inline">
          <input type="text" disabled />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { DateService } from '../../utils/dateService'

export default {
  name: 'ModalRetrieveFilterBy',

  props: {
    multi: {
      type: Boolean
    },
    heli: {
      type: Object
    },
    isLogsMode: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    option(newVal) {
      this.$emit('option-changed', newVal);
    },
    nonRetrievableSessions(newVal) {
      this.$emit('non-retrievable-changed', newVal);
    }
  },

  data () {
    return {
      option: '',
      date: null,
      dateRange: [],
      yourSessionItems: [],
      sessionNumber: '',
      selectedSessions: [],
      menu: false,
      dataToReturn: {},
      calendarLabel: this.$t('global.calendar_label'),
      calendarRangeLabel: this.$t('global.calendar_range_label'),
      yourSessionLabel: this.$t('global.select_your_session'),
      sessionLabel: this.$t('global.session_label'),
      nonRetrievableSessions: []
    }
  },

  computed: {
    // Generates a unique prefix for HTML attributes to prevent DOM collisions
    idPrefix() {
      return this.isLogsMode ? 'logs_' : 'sessions_';
    },

    formattedRange () {
      if (this.dateRange.length != 2) return ''

      let from = this.$moment(this.dateRange[0])
      let to   = this.$moment(this.dateRange[1])

      if (to.isAfter(from)) {
        return from.format('D MMM YYYY') + ' - ' + to.format('D MMM YYYY')
      } else {
        return to.format('D MMM YYYY') + ' - ' + from.format('D MMM YYYY')
      }
    },
    formattedDate () {
      if (!this.date) return ''
      return this.$moment(this.date).format('D MMM YYYY')
    }
  },
  methods: {
    getFiltersData () {
      return this.dataToReturn
    },
    getSessionsRadio () {
      this.clearInputs();
      let formData = new FormData()

      formData.append('registration', this.heli.registration)
      formData.append('serial', this.heli.serial)
      formData.append('type', this.heli.type)

      this.$requester
        .post('/list_sessions', formData)
        .then(response => {
          if (response.data &&
              response.data.retrievable_session &&
              response.data.not_retrievable_session) {
                let sessionItems = [
                  ...response.data.retrievable_session.map(session => ({
                    text: session,
                    value: session,
                    disabled: false,
                  })),
                  ...response.data.not_retrievable_session.map(session => ({
                    text: session + " (" + this.$t('sessionFilters.unavailable_retrieve') + ")",
                    value: session,
                    disabled: true,
                  })),
                ];

                sessionItems.sort((a, b) => {
                  let a_split = a.value.split("_");
                  let b_split = b.value.split("_");
                  let s1 = a_split[3] + a_split[4];
                  let s2 = b_split[3] + b_split[4];

                  if (s1 > s2) {
                    return -1;
                  }
                  else if (s1 < s2) {
                    return 1;
                  }
                  else {
                    return 0;
                  }
                });

                this.yourSessionItems = sessionItems;
                this.nonRetrievableSessions = response.data.not_retrievable_session;
              }
          else {
            console.log("/list_sessions: The response is not formatted correctly.")
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    clearInputs () {
      this.option = ''
      this.date = null
      this.dateRange = []
      this.sessionNumber = ''
      this.dataToReturn = {}
      this.selectedSessions = []
    },
    setByLastSessionRadio () {
      this.clearInputs()
      this.dataToReturn = {
        option: 'last_session'
      }
      this.updateInputValidEvent()
    },
    setBySessionRadio() {
      this.clearInputs();
      this.updateInputValidEvent()
    },
    setBySession () {
      this.dataToReturn = {
        option: 'specific_session',
        session: this.sessionNumber
      }
      this.updateInputValidEvent()
    },
   setSessionOfDayRadio() {
     this.clearInputs()
     this.updateInputValidEvent()
   },
    setSessionOfDay () {
      if (!this.date) {
        this.dataToReturn = {}
        this.updateInputValidEvent()
        return
      }

      const formattedDate = DateService.formatCalendarDate(this.date)
      let from_date = null;
      let to_date = null;
      if (formattedDate) {
        from_date = this.$moment(formattedDate)
        to_date   = this.$moment(from_date).add(1, 'days')
      }

      if (from_date && to_date) {
        this.dataToReturn = {
          option: 'between_dates',
          from_date: from_date.utc().format(),
          to_date: to_date.utc().format()
        }
      }

      this.menu = false // Close the calendar modal after selection
      this.updateInputValidEvent()
    },
    setSessionBetweenRadio() {
      this.clearInputs();
      this.updateInputValidEvent()
    },
    setSessionBetween () {
      if (this.dateRange.length !== 2) {
        this.dataToReturn = {}
        this.updateInputValidEvent()
        return
      }

      const formattedRange = this.dateRange.map(date =>
        DateService.formatCalendarDate(date)
      )

      const from_date_moment = this.$moment(formattedRange[0]);
      const to_date_moment = this.$moment(formattedRange[1]);

      let final_from_date;
      let final_to_date;

      // Add one day to "to_date" because it is excluded.
      // We look for sessions from "from_date" 00:00:00 to "to_date" 23:59:59 (which is the same as "to_date+1" 00:00:00 excluded)
      if (from_date_moment && to_date_moment) {
        // Swap the dates if the user selected them in reverse order
        if (from_date_moment.isAfter(to_date_moment)) {
          final_from_date = to_date_moment.utc().format();
          final_to_date = from_date_moment.clone().add(1, 'days').utc().format();
        } else {
          final_from_date = from_date_moment.utc().format();
          final_to_date = to_date_moment.clone().add(1, 'days').utc().format();
        }
      }

      this.dataToReturn = {
        option: 'between_dates',
        from_date: final_from_date,
        to_date: final_to_date
      }

      this.updateInputValidEvent()
    },
    closeDatePicker () {
      this.menu = false // Close the date range picker after selecting "OK"
    },
    setByYourSession () {
      this.dataToReturn = {
        option: 'specific_session',
        session: this.selectedSessions.join(',')
      }

      this.updateInputValidEvent()
    },
    isValid() {
      const filtersData = this.dataToReturn;
      if (filtersData && filtersData.option) {
        if (filtersData.option === 'specific_session') {
          if (!filtersData.session || filtersData.session.length === 0) {
            return false;
          }
        }
        else if (filtersData.option === 'between_dates') {
          if (!filtersData.from_date || !filtersData.to_date) {
            return false;
          }
        } else if (filtersData.option === 'last_session') {
          // no params
        } else {
          return false;
        }

        return true
        
      } else {
        return false
      }
    },

    getNonRetrievableSessions() {
      return this.nonRetrievableSessions;
    },

    getCurrentOption() {
      if (this.option) {
        return this.option;
      }
      else {
        return 'undef';
      }
    },

    updateInputValidEvent() {
      this.$emit('event-input-valid', this.isValid())
    }

  }
}
</script>




<style lang="scss">
.v-input__slot {
  margin: 0 !important;
}
</style>